<div class="welldone-card">
    <div class="welldone-card-body">
        <form #resetPassword="ngForm" class="w-100">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="old-password" class="form-label">Inserisci la vecchia password</label>
                            <input type="password" class="form-control" id="old-password" name="old-password" [(ngModel)]="oldPassword" required >
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-6">
                        <div class="mb-3">
                            <label for="new-password" class="form-label">Inserisci la nuova password</label>
                            <input type="password" class="form-control" id="new-password" name="new-password" [(ngModel)]="newPassword" required>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="mb-3">
                            <label for="confirm-password" class="form-label">Re-inserisci la nuova password</label>
                            <input type="password" class="form-control" id="confirm-password" name="confirm-password" [(ngModel)]="confirmPassword" required>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="welldone-card-footer">
        <button class="btn btn-primary" [disabled]="resetPassword.invalid || !passwordMatch()" (click)="resetPasswordHandler()"> Aggiorna password</button>
    </div>
</div>
